import { ROUTER_PATHS } from "@/shared";
import { ForumRounded } from "@mui/icons-material";
import { Fab } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ChatAgendamiento1: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Fab
      color="primary"
      aria-label="add"
      style={{
        position: "fixed",
        bottom: 16,
        right: 16,
      }}
      onClick={() => navigate(ROUTER_PATHS.operaciones.bitacoraPylNav)}
    >
      <ForumRounded />
    </Fab>
  );
};

export default ChatAgendamiento1;
